import {IconType} from "react-icons";
import {MdOutlineSettings} from "react-icons/md";
import {TbUsers} from "react-icons/tb";
import {BiCategory} from "react-icons/bi";
import {GrAnnounce} from "react-icons/gr";
import {RiMoneyDollarCircleLine} from "react-icons/ri";

import {ROLES_ID} from "../../utils/roles";
import {IoBriefcaseOutline} from "react-icons/io5";

export interface TLink {
  title: string;
  path: string;
  allowedTo: number[];
  userHas?: string;
}

export interface TNavGroup {
  key: string;
  title: string;
  icon: IconType;
  links: TLink[];
}

export const overviewLinks: TLink[] = [
  {
    title: "الرئيسية",
    path: "/",
    allowedTo: [ROLES_ID.ADMIN],
  },
  {
    title: "الرئيسية",
    path: "/marketer",
    allowedTo: [ROLES_ID.MARKETER],
  },
  {
    title: "الاحصائيات",
    path: "/statistics",
    allowedTo: [ROLES_ID.ADMIN],
  },
];

export const navGroups: TNavGroup[] = [
  {
    key: "users-business",
    title: "المستخدمون والأنشطة",
    icon: TbUsers,
    links: [
      {title: "المستخدمين", path: "/users", allowedTo: [ROLES_ID.ADMIN]},
      {title: "المسوقين", path: "/marketers", allowedTo: [ROLES_ID.ADMIN]},
      {title: "المدن", path: "/cities", allowedTo: [ROLES_ID.ADMIN]},
      {
        title: "الأنشطة والخدمات",
        path: "/businesses",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {title: "العروض", path: "/offers", allowedTo: [ROLES_ID.ADMIN]},
      {
        title: "طلبات الانضمام",
        path: "/businesses/join-requests",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "طلبات الانضمام",
        path: "/marketer/businesses/join-requests",
        allowedTo: [ROLES_ID.MARKETER],
        userHas: "can_manage_business_requests",
      },
      {
        title: "استمارات الانضمام",
        path: "/marketer/business-forms",
        allowedTo: [ROLES_ID.MARKETER],
      },
    ],
  },
  {
    key: "jobs",
    title: "الوظائف",
    icon: IoBriefcaseOutline,
    links: [
      {title: "الوظائف المتاحة", path: "/jobs", allowedTo: [ROLES_ID.ADMIN]},
      {
        title: "طلبات البحث عن وظائف",
        path: "/job-search-requests",
        allowedTo: [ROLES_ID.ADMIN],
      },
    ],
  },
  {
    key: "content",
    title: "المحتوى",
    icon: BiCategory,
    links: [
      {
        title: "تصنيفات الأنشطة والخدمات",
        path: "/categories/business?type=business",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "تصنيفات الأسئلة الشائعة",
        path: "/categories/faq",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "تصنيفات الوظائف",
        path: "/categories/job-search?type=job-search",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "تصنيفات المؤهلات العلمية",
        path: "/categories/job-education-level",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "تصنيفات الخبرة",
        path: "/categories/job-experience-years",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "تصنيفات الجنسيات",
        path: "/categories/job-nationality",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "خيارات كيف سمعت عن مقصود",
        path: "/categories/heard-about",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {title: "الوسوم", path: "/tags", allowedTo: [ROLES_ID.ADMIN]},
      {title: "الأسئلة الشائعة", path: "/faq", allowedTo: [ROLES_ID.ADMIN]},
      {title: "البانرز", path: "/banners", allowedTo: [ROLES_ID.ADMIN]},
      {
        title: "نتائج البحث الفارغة",
        path: "/empty-search?sorts=-count",
        allowedTo: [ROLES_ID.ADMIN],
      },
    ],
  },
  {
    key: "marketing",
    title: "التسويق والتواصل",
    icon: GrAnnounce,
    links: [
      {
        title: "ارسال اشعار",
        path: "/notifications/push",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "ادارة الاشعارات المرسلة",
        path: "/notifications/requests",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "الاستفسارات والاقتراحات",
        path: "/suggestions",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "إدارة الباقات",
        path: "/service-packages?service_type=banner",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "طلبات الشراء",
        path: "/service-purchase-requests",
        allowedTo: [ROLES_ID.ADMIN],
      },
    ],
  },
  {
    key: "finance",
    title: "الماليات",
    icon: RiMoneyDollarCircleLine,
    links: [
      {
        title: "التسويات المالية للمسوقين",
        path: "/settlements",
        allowedTo: [ROLES_ID.ADMIN],
      },
      {
        title: "المعاملات المالية",
        path: "/transactions",
        allowedTo: [ROLES_ID.ADMIN],
      },
    ],
  },
  {
    key: "system",
    title: "النظام",
    icon: MdOutlineSettings,
    links: [
      {title: "سجل النشاط", path: "/logs", allowedTo: [ROLES_ID.ADMIN]},
      {title: "الضبط", path: "/settings", allowedTo: [ROLES_ID.ADMIN]},
    ],
  },
];
